var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100vh"}},[(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_c('p',[_vm._v("Redirecting...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }